import { useMutation, useQueryClient } from 'react-query';
import { PhoneNumbersV1 } from '@frontend/api-phone-numbers';
import { PortingQueries } from '@frontend/api-porting';
import { PhoneNumberSchemaService, SchemaTenDLCCoordinator } from '@frontend/schema';
import {
  RegisterPhoneNumberPayload,
  SetLocationSmsPayload,
  UpdateNamePayload,
  UpdateOutboundCallerIdPayload,
} from './types';

export const usePhoneNumbersTableMutations = (locationIds: string[]) => {
  const queryClient = useQueryClient();

  const register = useMutation({
    mutationFn: (payload: RegisterPhoneNumberPayload) => {
      return SchemaTenDLCCoordinator.RegisterPhoneNumber(payload, {
        headers: {
          'Location-Id': payload.locationId,
        },
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries(PortingQueries.queryKeys.phoneNumbers(locationIds));
    },
  });

  const setLocationSms = useMutation({
    mutationFn: (payload: SetLocationSmsPayload) => {
      return PhoneNumberSchemaService.SetLocationSms(payload);
    },
    onSettled: () => {
      queryClient.invalidateQueries(PortingQueries.queryKeys.phoneNumbers(locationIds));
    },
  });

  const updateName = useMutation({
    mutationFn: (payload: UpdateNamePayload) => {
      return PhoneNumberSchemaService.UpdateDisplayName(payload);
    },
    onSettled: () => {
      queryClient.invalidateQueries(PortingQueries.queryKeys.phoneNumbers(locationIds));
      queryClient.invalidateQueries([PhoneNumbersV1.Service.serviceName, 'ListPhoneNumbersForLocations']);
    },
  });

  const updateCallerOutboundId = useMutation({
    mutationFn: (payload: UpdateOutboundCallerIdPayload) => {
      return PhoneNumberSchemaService.UpdateOutboundCallerID(payload);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(PortingQueries.queryKeys.phoneNumbers(locationIds), (old: any) =>
        (old ?? []).map((number: any) => (number.id === data.id ? { ...number, ...data } : number))
      );
    },
  });

  return {
    register,
    setLocationSms,
    updateName,
    updateCallerOutboundId,
  };
};
